import { render, staticRenderFns } from "./payFeeDiscount.vue?vue&type=template&id=1d8c5aec&scoped=true"
import script from "./payFeeDiscount.vue?vue&type=script&lang=js"
export * from "./payFeeDiscount.vue?vue&type=script&lang=js"
import style0 from "./payFeeDiscount.vue?vue&type=style&index=0&id=1d8c5aec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8c5aec",
  null
  
)

export default component.exports